<script>
  export let status = '';
  export let variant = 'default'; // default, primary, success, warning, error, info
  export let size = 'md'; // sm, md, lg
</script>

{#if status}
  <span class="status-badge status-badge-{variant} status-badge-{size}">
    {status}
  </span>
{/if}

<style>
  .status-badge {
    display: inline-block;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 20px;
    line-height: 1.2;
  }

  /* Size variants */
  .status-badge-sm {
    padding: 3px 8px;
    font-size: 0.75rem;
  }

  .status-badge-md {
    padding: 5px 12px;
    font-size: 0.85rem;
  }

  .status-badge-lg {
    padding: 8px 16px;
    font-size: 0.95rem;
  }

  /* Color variants */
  .status-badge-default {
    background-color: #f1f3f5;
    color: #495057;
  }

  .status-badge-primary {
    background-color: #e7f5ff;
    color: #3273dc;
  }

  .status-badge-success {
    background-color: #d3f9d8;
    color: #2b8a3e;
  }

  .status-badge-warning {
    background-color: #fff9db;
    color: #f59f00;
  }

  .status-badge-error {
    background-color: #ffe3e3;
    color: #e03131;
  }

  .status-badge-info {
    background-color: #e5dbff;
    color: #7950f2;
  }

  /* Status-specific styles (backward compatibility) */
  .status-badge.applied {
    background-color: #e7f5ff;
    color: #3273dc;
  }

  .status-badge.reviewing {
    background-color: #fff9db;
    color: #f59f00;
  }

  .status-badge.proceeding {
    background-color: #d3f9d8;
    color: #40c057;
  }

  .status-badge.accepted {
    background-color: #b2f2bb;
    color: #2b8a3e;
  }

  .status-badge.rejected {
    background-color: #ffe3e3;
    color: #e03131;
  }

  .status-badge.project_canceled,
  .status-badge.canceled {
    background-color: #ffe3e3;
    color: #fa5252;
  }

  .status-badge.project_delayed {
    background-color: #e5dbff;
    color: #7950f2;
  }

  .status-badge.closed {
    background-color: #f1f3f5;
    color: #868e96;
  }

  .status-badge.모집중 {
    background-color: #e7f5ff;
    color: #3273dc;
  }

  .status-badge.마감 {
    background-color: #f1f3f5;
    color: #495057;
  }

  .status-badge.종료 {
    background-color: #fff5f5;
    color: #fa5252;
  }
</style> 